import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SchedulePayrollBatch from "../SchedulePayrollBatch/SchedulePayrollBatch";
import PayrollHistoryTab from "../PayrollHistoryTab/PayrollHistoryTab";
import ReviewPayrollBatch from "../ReviewPayrollBatch/ReviewPayrollBatch";
import "./PayrollBatchTabs.scss";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`payroll-tabpanel-${index}`}
      aria-labelledby={`payroll-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, backgroundColor: "white", borderRadius: "0 8px 8px 8px" }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `payroll-tab-${index}`,
    "aria-controls": `payroll-tabpanel-${index}`,
  };
}

export default function PayrollBatchTabs({ batchList, userPermissions, getNewBatchList }) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }} className="payroll-batch-tabs-root">
      <Box sx={{ borderBottom: 1, borderColor: "divider", backgroundColor: "#f8f8f8", borderRadius: "12px 12px 0 0" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "capitalize",
              color: "#BCBCBC",
              fontFamily: "Inter",
              fontSize: 15,
              fontWeight: 500,
              minWidth: 180,
              "&.Mui-selected": {
                backgroundColor: "white",
                color: "#5523D2",
                fontWeight: 600,
                borderRadius: "8px 8px 0 0",
                zIndex: 1,
              },
            },
          }}
        >
          <Tab label="Scheduler" {...a11yProps(0)} />
          <Tab label="Review" {...a11yProps(1)} />
          <Tab label="History" {...a11yProps(2)}/>
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <SchedulePayrollBatch
          batchList={batchList}
          userPermissions={userPermissions}
          onUpdate={getNewBatchList}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <PayrollHistoryTab batchList={batchList} userPermissions={userPermissions} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
  <ReviewPayrollBatch />  
</CustomTabPanel>
    </Box>
  );
}